// app.js

import React, { useState, useEffect } from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import './css/App.css';
import MessageMonitor, { MessageSearchControls } from './components/MessageMonitor.js';
import { Authenticator } from '@aws-amplify/ui-react';
import CookieConsent from 'react-cookie-consent';
import { WebSocketProvider } from './contexts/WebSocketContext.js';
import { DatabaseProvider } from './contexts/DatabaseContext.js';
import { fetchUserAttributes } from 'aws-amplify/auth';

function App() {
  const websocketUrl = process.env.REACT_APP_WS_URL;

  return (
    <>
      <CookieConsent>
        This website uses cookies
      </CookieConsent>
      <div className="auth-container">
        <Authenticator signUpAttributes={['email']}>
          {({ signOut, user }) => (
            <AuthenticatedApp
              signOut={signOut}
              user={user}
              websocketUrl={websocketUrl}
            />
          )}
        </Authenticator>
      </div>
    </>
  );
}

function AuthenticatedApp({ signOut, user, websocketUrl }) {
  const [kycComplete, setKycComplete] = useState(false);
  const [authReady, setAuthReady] = useState(false);
  const amplifyUsername = user?.username ?? '';

  useEffect(() => {
    let active = true;

    const loadUserAttributes = async () => {
      if (!user) {
        setAuthReady(false);
        setKycComplete(false);
        return;
      }

      try {
        const attributes = await fetchUserAttributes();
        if (!active) {
          return;
        }

        console.log('Fetched Attributes:', attributes);
        setKycComplete(attributes['custom:kycComplete'] === 'true');
        setAuthReady(true);
      } catch (error) {
        if (!active) {
          return;
        }

        console.log('Error fetching user attributes:', error);
        setKycComplete(false);
        setAuthReady(true);
      }
    };

    loadUserAttributes();

    return () => {
      active = false;
    };
  }, [user]);

  return (
    <WebSocketProvider url={websocketUrl}>
      <DatabaseProvider websocketUrl={authReady && user ? websocketUrl : ''}>
        <div className="App">
          <Header user={user} signOut={signOut} />
          <div className="content-container">
            <Routes>
              <Route
                path="/"
                element={<MessageMonitor amplifyUsername={amplifyUsername} kycComplete={kycComplete} />}
              />
            </Routes>
          </div>
          <Footer />
        </div>
      </DatabaseProvider>
    </WebSocketProvider>
  );
}

const Header = ({ user, signOut }) => (
  <header className="App-header">
    <div className="nav-container">
      <img
        src={`${process.env.PUBLIC_URL}/fx.jpg`}
        alt="FX Logo"
        className="nav-logo"
      />
      <nav className="nav-links">
        <Link to="/">Home</Link>
        <MessageSearchControls />
        {user && <button className="sign-out-button" onClick={signOut}>Sign Out</button>}
      </nav>
    </div>
  </header>
);

const Footer = () => (
  <footer className="App-footer">
    <div className="footer-content">
    </div>
  </footer>
);

export default App;
